import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/sc-rewards.png'


const _hoisted_1 = { class: "rewardImage" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = ["alt"]
const _hoisted_4 = { class: "data" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_6 = { class: "points" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: { name: 'Reward', params: { id: _ctx.reward.id } },
    class: "rewardBox"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.reward.image)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.reward.image.url,
              alt: _ctx.$t('accessibility.reward.reward_image')
            }, null, 8, _hoisted_2))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: _imports_0,
              alt: _ctx.$t('accessibility.reward.reward_image')
            }, null, 8, _hoisted_3))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.name), 1),
        _hoisted_5,
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.reward.value) + " " + _toDisplayString(_ctx.$t("rewards.points")), 1)
      ])
    ]),
    _: 1
  }, 8, ["to"]))
}